import type { BuildFields } from 'ra-data-hasura';

const userDAO = (defaultFields: BuildFields) => {
  const fields = [];
  for (const field of defaultFields) {
    if (field?.name?.value !== "password") {
      fields.push(field);
    }
  }
  return fields;
};

export default userDAO;